// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import * as firebase from 'firebase'

import('../node_modules/vuetify/dist/vuetify.min.css')

Vue.use(Vuetify)
Vue.config.productionTip = false


let fbConfig = {
    apiKey: "AIzaSyD6qJhaVzAIrKmO6Ax3a34STJ58J4MHvvo",
    authDomain: "tsposeidon-192421.firebaseapp.com",
    databaseURL: "https://tsposeidon-192421.firebaseio.com",
    projectId: "tsposeidon-192421",
    storageBucket: "tsposeidon-192421.appspot.com",
    messagingSenderId: "455874319169"
}

var app = firebase.initializeApp(fbConfig);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


/*firebase.auth().onAuthStateChanged(function(user){

  if(!Application) {

    Application = new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  }
});*/


// WEBPACK FOOTER //
// ./src/main.js